import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import AuthReducer from './AuthReducer'
import thunk from 'redux-thunk';
// import { composeWithDevTools } from '@redux-devtools/extension';


const reducers = combineReducers({
    AuthReducer: AuthReducer,
})

export const store = createStore(reducers, composeWithDevTools((applyMiddleware(thunk)))   
)